<template>
  <VDialog v-model="isVisible" width="400px" persistent attach="#LetsPage">
    <VeeForm ref="observer">
      <VCard>
        <VCardTitle class="pb-0">
          {{ $t('C11101.C11101MeetingChecklistDialog.chekkurisuto') }}
        </VCardTitle>
        <VCardText v-debug>
          <h3>dialogData</h3>
          {{dialogData}}
        </VCardText>
        <VCardText v-if="dialogData">
          <VCheckbox
            v-for="item in dialogData.checkList"
            :key="item.id"
            v-model="outputData.checkList"
            :label="item"
            :value="item"
            hide-details
            multiple
            class="ma-0"
          />
        </VCardText>
        <VCardText v-debug>
          <h3>outputData</h3>
          {{outputData}}
        </VCardText>
        <VCardActions>
          <VSpacer></VSpacer>
          <VBtn
            color="blue lighten"
            style="color: white"
            :disabled="outputData?.checkList?.length !== dialogData?.checkList?.length"
            @click="emitOk"
          >
            {{ $t('C11101.C11101MeetingChecklistDialog.ru-shi') }} </VBtn>
          <VBtn variant="text" @click="emitCancel">
            {{ $t('common.cancel') }} </VBtn>
        </VCardActions>
      </VCard>
    </VeeForm>
  </VDialog>
</template>

<script>
import DialogMixin from '@/mixins/DialogMixin.js';
export default {
  components:{
  },
  mixins:[
    DialogMixin
  ],
  data() {
    return {
    };
  },
  methods:{
  }

}
</script>

<style scoped>
span {
  font-size: 1rem
}
.v-card__text{
  font-size: 1rem;
}
</style>
